let currentTransition = 0
let interval = null
const segmentTransitionTime = 1400
let barWidth = null

window.addEventListener('DOMContentLoaded', () => {
	const aFrames = document.querySelectorAll('.aFrame')
	const bFrames = document.querySelectorAll('.bFrame')
	const progressBar = document.querySelector('#progressBar')
	const fullProgressBar = document.querySelector('#fullProgressBar')

	const initialize = () => {
		if(interval){
			clearInterval(interval)
			interval = null
		}
		barWidth = fullProgressBar.getBoundingClientRect().width - 45
		setToStep(0)
		startAnimation()
	}

	const setToStep = (step) => {
		currentTransition = step
		aFrames.forEach((elt, index) => {
			if (index === step) {
				elt.style.opacity = 1
			} else {
				elt.style.opacity = 0
			}
		})
		bFrames.forEach((elt, index) => {
			if (index === step) {
				elt.style.opacity = 1
			} else {
				elt.style.opacity = 0
			}
		})
		// if (!(currentTransition === 0)) {
		progressBar.style.width = 22.5 + (barWidth / 5) * step + 'px'
		// } else {
		// 	progressBar.classList.remove('duration-500')
		// 	progressBar.classList.add('duration-[250ms]')
		// 	progressBar.style.width =
		// 		progressBar.getBoundingClientRect().width + 22.5 + 'px'
		// 	setTimeout(() => {
		// 		progressBar.classList.remove('transition-all', 'duration-[250ms]')
		// 		progressBar.style.width = 0
		// 		progressBar.classList.add('transition-all', 'duration-[250ms]')
		// 		progressBar.style.width = '22.5px'
		// 		setTimeout(() => {
		// 			progressBar.classList.remove('duration-[250ms]')
		// 			progressBar.classList.add('duration-500')
		// 		})
		// 	}, 250)
		// }
	}

	const createAnimation = () => {
		if (currentTransition === 5) {
			currentTransition = 0
		} else {
			currentTransition++
		}
		setToStep(currentTransition)
	}

	const startAnimation = () => {
		createAnimation()
		interval = setInterval(() => {
			createAnimation()
		}, segmentTransitionTime)

		icons.forEach((elt) => {
			if(elt.id === 'playIcon'){
				elt.classList.add('opacity-0')
			}
			if(elt.id === 'pauseIcon'){
				elt.classList.remove('opacity-0')
			}
		})
	}

	const stopAnimation = (step) => {
		if (step !== null && step >= 0) {
			setToStep(step)
		}
		clearInterval(interval)
		interval = null

		icons.forEach((elt) => {
			if (elt.id === 'pauseIcon') {
				elt.classList.add('opacity-0')
			}
			if (elt.id === 'playIcon') {
				elt.classList.remove('opacity-0')
			}
		})
	}

	const dots = document.querySelectorAll('.pause-dot')
	dots.forEach((dot) => {
		const segment = dot.dataset.segment
		dot.firstChild.addEventListener('click', () => {
			stopAnimation(Number(segment))
		})
	})
	const pauseButton = document.querySelector('#pauseButton')
	const icons = [...pauseButton.children]
	pauseButton.addEventListener('click', () => {
		if (interval) {
			stopAnimation()
		} else {
			startAnimation()
		}
	})

	window.addEventListener('resize', initialize)

	initialize()
})
